// Tiny editorial peek of XP + streak that lives in the Library header.
// Acts as a teaser/affordance for the full /profile page. Whisper-quiet by
// design — these numbers shouldn't compete with the library grid.

import React from "react";
import { Link } from "react-router-dom";
import { formatXp, levelFromXp, levelRoman } from "../lib/levels";
import { useCurrentUser } from "../lib/use-current-user";

export default function LibraryPeek() {
  const { profile, loading } = useCurrentUser();
  if (loading || !profile) return null;
  const { stats } = profile;
  const lvl = levelFromXp(stats.xp);

  return (
    <Link
      to="/profile"
      className="group inline-flex items-baseline gap-3 sm:gap-4 font-display tabular-nums text-gray-400 hover:text-orange-200 transition"
    >
      <span className="text-base">
        <span className="text-gray-200 group-hover:text-orange-200 transition">
          {formatXp(stats.xp)}
        </span>
        <span className="ml-1 text-[10px] tracking-[0.25em] uppercase text-gray-500 group-hover:text-orange-300/70">
          xp
        </span>
      </span>
      <span aria-hidden className="text-gray-700">
        /
      </span>
      <span className="text-sm">
        <span className="font-display-italic text-gray-400 group-hover:text-orange-200">
          L{levelRoman(lvl.level)}
        </span>
      </span>
      {stats.currentStreak > 0 ? (
        <>
          <span aria-hidden className="text-gray-700">
            /
          </span>
          <span className="text-sm">
            <span className="text-orange-300/90 group-hover:text-orange-200">
              {stats.currentStreak}
            </span>
            <span className="ml-1 text-[10px] tracking-[0.25em] uppercase text-gray-500 group-hover:text-orange-300/70">
              {stats.currentStreak === 1 ? "day" : "days"}
            </span>
          </span>
        </>
      ) : null}
      <span
        aria-hidden
        className="text-gray-600 group-hover:text-orange-300 transition"
      >
        →
      </span>
    </Link>
  );
}
